<script setup>
import { computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useTranslaterStore } from '@/stores/translater'

const route = useRoute()
const router = useRouter()
const translaterStore = useTranslaterStore()

const getTranslate = computed(() => translaterStore.getTranslate)

const breadcrumbs = computed(() => {
    const crumbs = []

    let currentRoute = route

    const paramKey = currentRoute.meta?.breadcrumbs?.params ?? currentRoute.meta.title

    crumbs.push({
        name: currentRoute.params[paramKey] ?? currentRoute.meta.title
    })

    let parent = currentRoute?.meta?.breadcrumbs?.parentName

    while (parent) {
        currentRoute = router.resolve({ name: parent }, route)

        if (!currentRoute) {
            parent = null
            break
        }

        const paramKey = currentRoute.matched.at(-1).meta?.breadcrumbs?.params

        crumbs.push({
            name: currentRoute?.params[paramKey] ?? currentRoute?.meta?.title,
            to: { name: currentRoute.name, params: currentRoute.params }
        })

        parent = currentRoute.meta?.breadcrumbs?.parentName
    }

    return crumbs.reverse()
})
</script>

<template>
    <nav class="asw-breadcrumbs navbar navbar-expand-md p-0" v-if="breadcrumbs.length">
        <div class="container-fluid h-100">
            <div class="asw-breadcrumbs__paths">
                <span v-for="(crumb, index) in breadcrumbs" :key="index" class="nav-item asw-breadcrumbs__path">
                    <template v-if="crumb.to">
                        <router-link :to="crumb.to" class="asw-breadcrumbs__path-link">{{
                            getTranslate[crumb.name] || crumb.name
                        }}</router-link>
                    </template>
                    <template v-else>
                        {{ getTranslate[crumb.name] || crumb.name }}
                    </template>
                    <span class="asw-breadcrumbs__separator" v-if="index < Object.keys(breadcrumbs).length - 1">
                        <span class="material-icons"> keyboard_arrow_right </span>
                    </span>
                </span>
            </div>
        </div>
    </nav>
</template>

<style lang="scss">
@use '@/assets/styles/scss/components/breadcrumbs';
</style>
